import { format } from 'date-fns'

export const formatDate = dateString => format(dateString, 'MMMM YYYY')



// WEBPACK FOOTER //
// ./src/components/cv/formatDate.js